import { Box, ButtonV2, FormControl } from '@withjoy/joykit';
import { Search } from '@withjoy/joykit/icons';
import React from 'react';
import { pxToRem } from '@withjoy/joykit/theme';

export const SubmitButton = () => {
  return (
    <FormControl>
      <ButtonV2
        type="submit"
        _hover={{ backgroundColor: 'newBrandPurple1' }}
        variant={'solid'}
        backgroundColor={'newUITest1'}
        intent={'neutral'}
        shape={'rounded'}
        width={pxToRem(48)}
        height={pxToRem(40)}
      >
        <Box alignItems={'center'} justifyContent={'center'}>
          <Search />
        </Box>
      </ButtonV2>
    </FormControl>
  );
};
